import React from "react";
import { Box, Typography } from "@mui/material";

const getInitials = (name = "") => {
  const p = name.trim().split(" ");
  return p.length === 1 ? p[0].slice(0, 2).toUpperCase() : (p[0][0] + p[p.length - 1][0]).toUpperCase();
};

const AVATAR_COLOR = "#28B3B4";

const Step3FTEAssociate = ({ associate, t }) => (
  <Box sx={{
    background: t.surface2, border: `1px solid ${t.border2}`,
    borderRadius: "3px", padding: "10px 14px", mb: "16px",
    display: "flex", alignItems: "center", gap: "10px",
  }}>
    <Box sx={{
      width: "32px", height: "32px", borderRadius: "50%", flexShrink: 0,
      background: `${AVATAR_COLOR}22`, border: `1px solid ${AVATAR_COLOR}55`,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'DM Mono', monospace", fontSize: "10px", fontWeight: 700, color: AVATAR_COLOR,
    }}>
      {getInitials(associate?.fullName)}
    </Box>
    <Box sx={{ flex: 1 }}>
      <Typography sx={{ fontFamily: "'Inter', sans-serif", fontSize: "13px", fontWeight: 600, color: t.text }}>
        {associate?.fullName}
      </Typography>
      <Typography sx={{ fontSize: "11px", color: t.text3 }}>
        Level {associate?.levelCode}
      </Typography>
    </Box>
    <Box sx={{ textAlign: "right" }}>
      {associate?.currentMacName && (
        <Typography sx={{ fontFamily: "'DM Mono', monospace", fontSize: "9px", color: t.text3, mb: "2px" }}>
          Currently in: {associate.currentMacName}
        </Typography>
      )}
      <Typography sx={{ fontFamily: "'DM Mono', monospace", fontSize: "9px", color: t.text3 }}>
        Current: {associate?.usedFte ?? 0}
      </Typography>
      <Typography sx={{ fontFamily: "'DM Mono', monospace", fontSize: "9px", color: t.accent }}>
        {associate?.availableFte ?? 1.0} HC available
      </Typography>
    </Box>
  </Box>
);

export default Step3FTEAssociate;